import './App.css';
import './common.scss';
import 'font-awesome/css/font-awesome.min.css';
import getRoutes from '../src/router/routerLinks';
import React from 'react';
import Header from '../src/components/Header/header';
import Sidebar from '../src/components/Sidebar/sidebar';
import { Routes, Route, BrowserRouter, useLocation } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "antd/dist/reset.css";
import Chatbot from '../src/pages/ChatBot/ChatBot';
import "react-toastify/dist/ReactToastify.css"; 
const Layout = () => {
  const location = useLocation();

  // Define public routes where Header & Sidebar should NOT appear
  const publicRoutes = ['/', '/login', '/register', '/verify-otp'];

  const isPublicRoute = publicRoutes.includes(location.pathname);

  return (
    <div className="app">
      {/* Only show Sidebar and Header if NOT on public routes */}
      {!isPublicRoute && <Sidebar />}
      {!isPublicRoute && <Header />}

      <div className={isPublicRoute ? '' : 'home-section1'}>
        <Routes>
          {getRoutes()?.map((val, i) => (
            <Route
              key={i}
              path={val.path}
              element={<val.component />}   // <-- DIRECT COMPONENT RENDER
            />
          ))}

          {/* Optional: Redirect unknown routes */}
          {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
        </Routes>
       {!isPublicRoute && <Chatbot />}
      </div>

    </div>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Layout />
    </BrowserRouter>
  );
};

export default App;
